// 页面JS逻辑文件
import Databus, { Origins } from "@ykz/ykz-http/core";
import {
  verifyPopularizer,
  makeVisitorFans,
  getUserPromotion,
} from "@ykz/ykz-http/common";
import component_app_download from "./../../../components/productDetail/app_download.vue";
import component_product_promotion from "./../../../components/productDetail/product_promotion.vue";
import component_room_detail from "./../../../components/room_detail.vue";
import appExclusive from "./components/appExclusive.vue";
import user_evaluation from "./../../../components/productDetail/user_evaluation.vue";
import buy_consult from "./../../../components/productDetail/buy_consult.vue";
import ComponentShareType from "@/components/productDetail/share_type.vue";
import ComponentTicketCalendar from "@/components/ticket_calendar.vue";
import productPoster from "./js/productPoster.js"; // 生成产品海报相关
import componentNavigationBtn from "@/components/productDetail/navigation_btn.vue";
// import ComponentRegisterGuide from "@/components/register_guide_popup.vue";
import ComponentEpidemicTips from "@/components/productDetail/epidemic_tips.vue";
import ComponentPlayGuide from "@/components/productDetail/play_guide.vue";
import previewMedia from "@/components/previewMedia/index.vue";
import XGPlayer from "@/components/XGPlayer.vue";
import {
  updateUrlParam,
  getUrlToken,
  toQueryString,
  toast,
  pressEvent,
} from "@ykz/ykz-util/base";
import {
  isAndroid,
  isYkzMiniprogram,
  isByteDanceMiniProgram,
  isOtherBrowsers,
  addQiniuParams,
  goToWxMiniPage,
} from "@ykz/ykz-util/platform";
import { getProductLink } from "@/util/common";
import { openLocation } from "@ykz/ykz-util/location/open";
import { lazyWithStr } from "../../../util/document";

import { lolila_2_nanuli_core } from "@/util/formatHtml";


const openApiGood =
  window.comm.openApiGood; /*是否开启使用api good域名host，0关闭，1开启*/

let componentCenter = window.componentCenter;

let page = {
  name: "goodsDetails",
  data() {
    return {
      goodsDetails: {
        photoNumber: 0,
      },
      //活动产品列表
      activityGoodsList: [],
      //常规产品列表
      commonGoodsList: [], //精选推荐
      commentInfos: null, //评论

      vShowPoster: false, //生成海报按钮
      vShowEmptyGood: false, //商品为空时显示
      isPopularizer: 0,
      promoter: {},
      defaultAvatar: window.comm.defaultUserAvatar,

      fromPlatform: getUrlParams("fromPlatform"),
      fromWeChatId: getUrlParams("fromWeChatId") || 1,
      weChatId: getUrlParams("weChatId") || window.weChatId || 1,
      cWechat: getUrlParams("cWechat") || "", //微商城自身的wechatId
      scenicId: getUrlParams("scenicId") || 1,
      activityId: getUrlParams("activityId") || "",
      checkInDate: getUrlParams("checkIn") || "", // 入住日期
      checkOutDate: getUrlParams("checkOut") || "", // 离店日期
      isShop:
        sessionStorage.getItem("session_isShop") || getUrlToken("isShop") || 0, // 店铺模式
      weChatType: window.comm.weChatType || 1, //1：直采和直销，2：市区娱乐(微商城)，3：渠道SIP直连，4：旅行社/综合类'(微商城)
      promotionProduct: {}, //公众号下推广产品

      timestamp: "",
      link: "",

      loadPasswordError: false, //是否口令生成失败
      password: "", //生成的口令
      appSellComm: 0, // app最高推广奖励
      sellComm: 0, // 微信最高推广奖励
      minPrice: null, // 最低价
      maxPrice: null, // 最高价

      isInApp: window.mobileEnv == "app" ? true : false, //是否在app打开
      isIOSReviewing: window.mobileEnv == "app" && ykzApp.isIOSReviewing(),
      isTourist: window.isTourist || false,
      isOtherBrowsers: isOtherBrowsers(), // 第三方浏览器
      isByteDance: isByteDanceMiniProgram(), // 在抖音小程序内
      showDownloadTips: false, // 显示更新app提示

      posterImg: "", // 酒景页海报
      promotion: "", // 分享串
      shareObj: {}, // 分享对象
      miniShareImgUrl: "", // 小程序分享图

      shortShareLink: "", // 短连接分享链接
      shortShareTxt: "", // 短链接分享文案




      album: [], //相册
      currentIndex: 1, // 记录当前轮播图index
      paused: true, //相册视频是否停止播放，默认true
      player: null,
      showVideo: false,
      mergeList: [],

      showAppExclusive: false, //app专享价弹窗
      showAppExclusiveGood: {}, //app专享价商品信息

      floatCommList: [], // 需要奖励上浮倒计时的产品
      commDiffTime: 0, // 倒计时用 服务器时间-本地时间

      /** 轮播图相关start */
      mySwiper: null,
      bannerIndex: 0,
      // 轮播图配置
      swiperOptions: {
        loop: false,
        autoHeight: true,   // 启用自动高度
        slidesPerView: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        onSlideChangeEnd: swiper => {
          this.onSlideChangeEnd(swiper);
        },
      },
      bannerList: [], // banner列表
      navList: [], // 导航列表
      showCoverImg: false, // 是否显示封面 一般只显示一次
      xgplayer: null,
      showStartBtn: false,
      showStopBtn: true,
      pauseIcon: 'https://qiniu-cdn6.jinxidao.com/group1/2025/01/16/15/36/596036788b6ed5854a.png',
      playIcon: 'https://qiniu-cdn7.jinxidao.com/wxProgram/images/zby/play_big_icon.png',
      isPreviewVisible: false,
      currentIndex: 0,
      mediaList: [],
      /** 轮播图相关end */

      ticket: {
        type: 8,
        alldayList: [],
        selectStartDate: {},
        selectEndDate: {},
        tempStartDate: {},
        tempEndDate: {},
        useDate: [],
      },
      showDatePicker: false, // 是否显示日期选择入口, 有客房才显示
      swiperNumber: 0, // swiper总共数量

      promotionCity: {}, // 商品推荐需要的地址
      isShowRegisterGuide: false, //展示自动注册提醒弹窗

      shareObjLink: "",
      isFirstShow: true, // 是否第一次进入商详页
      screenHeight: window.innerHeight, // 当前屏幕高度
      buyNotesExpand: true,

      imgTxtFormated:"",


    };
  },
  components: {
    "component-app-download": component_app_download,
    "component-room-detail": component_room_detail,
    "component-product-promotion": component_product_promotion,
    appExclusive,

    "user-evaluation": user_evaluation,
    "buy-consult": buy_consult,
    ComponentShareType,
    ComponentTicketCalendar,
    "component-navigation-btn": componentNavigationBtn,
    // ComponentRegisterGuide,
    ComponentEpidemicTips,
    ComponentPlayGuide,
    'xg-player': XGPlayer,
    previewMedia
  },
  created() {
    var that = this;

    this.initSessionData();

    var promiseUser = new Promise(function (resolve, reject) {
      that.ajaxGetUserInfo(resolve, reject);
    });

    databus.makeVisitorFans(); //访客浏览转化成推广员的粉丝

    var promiseA = new Promise(function (resolve, reject) {
      that.ajaxGetGoodsDeatail(resolve, reject);
    });

    var promiseB = new Promise(function (resolve, reject) {
      that.ajaxGetGoodsList(resolve, reject);
    }).then(function () {
      return new Promise(function (resolve, reject) {
        // 拿奖励
        that.ajaxGetExtendGoods(resolve, reject);
        // 拿绑定的下单任务
        that.getBindOrderTask();
      });
    });

    this.fetchOfficialAlbum();  // 获取酒景相册

    Promise.all([promiseA, promiseB]).then(function () {
      that.handleSortList(that.activityGoodsList); // 处理奖励，海报
      that.handleSortList(that.commonGoodsList); // 处理奖励，海报



      that.initCountDown(); // 奖励上浮倒计时
      that.initCopyPassword(); // 初始化口令
      that.saveImage(); // 安卓长按保存图片功能

   
      if (!that.isShop) {
        that.$refs.promotion.init(); //商品推荐初始化
      }
    });

    Promise.all([promiseA, promiseUser]).then(() => {
      // 店铺模式不弹定位授权
      if (this.isShop) {
        return;
      }

      if (
        this.promoter &&
        this.promoter.isPopularizer &&
        this.promoter.promoterId
      ) {
        window.UnifyUpdatePromoterLocation({
          promoterId: this.promoter.promoterId,
          city: this.goodsDetails.cityName || "",
          province: this.goodsDetails.provinceName || "",
          district: this.goodsDetails.districtName || "",
          latitude: this.goodsDetails.latitude || "",
          longitude: this.goodsDetails.longitude || "",
        });
      } else {
        //c用户定位上报
        window.UpdateCUserLocation({
          city: this.goodsDetails.cityName || "",
          province: this.goodsDetails.provinceName || "",
          district: this.goodsDetails.districtName || "",
          latitude: this.goodsDetails.latitude || "",
          longitude: this.goodsDetails.longitude || "",
        });
      }
    });

    if (that.isInApp) {
      document.title = window.comm.weChatName;

      ykzApp.ready(function () {
        // 监听回到顶部事件
        ykzApp.onResponse["scrollToTop"] = function () {
          that.scrollToTop();
        };
      });
    }

    if (this.isOtherBrowsers) {
      this.promotion = getUrlParams("promotion");
    }

    YCF_Plugin.anchorPoint(
      "酒景页展示",
      "productdetail_show",
      `scenicId:${this.scenicId}`
    );

    //大数据锚点
    this.logHelpers({
      event_id: "500047",
      event_content: {
        channel_id: window.sessionStorage.getItem("channel_ref") || "",
      },
    });

    //批量海报
    window.BatchPoster = new YCF_Plugin.batchPoster({
      classname: ".product-item",
      type: 2,
      bottom: 88,
    });
  },
  mounted: function () {
    // 利用hash处理返回事件
    this.handleHash();
    // v5.1.8微信授权需求，君伦让调起的
    YCF_Plugin.initABTest();
  },
  filters: {
    //日期格式化
    formatDate: function (timestamp) {
      var nowYear = new Date(/*timestamp * 1000*/).getFullYear();
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() !== nowYear ? date.getFullYear() + "年" : "";
      var M = date.getMonth() + 1 + "月";
      var D = date.getDate() + "日 ";
      var h =
        (date.getHours() > 9 ? date.getHours() : "0" + date.getHours()) + ":";
      var m =
        date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
      return Y + M + D + h + m;
    },
    formatDate2(val) {
      if (!val) return;
      var arr = val.split("-");
      if (arr && arr.length == 3) {
        return arr[1] + "月" + arr[2] + "日";
      }
    },
    formatName: function (name) {
      return name.substring(0, 1) + "**";
    },
    formatScore: function (score) {
      if (score < 10000) {
        return score;
      }

      if (score % 10000 == 0) {
        return score / 10000 + ".0万";
      }

      return (score / 10000).toFixed(1) + "万+";
    },
    //过滤指定规则的重复字符串
    filterRepeatStr: function (value) {
      var val = value;
      if (typeof val == "string" && val.length >= 6) {
        filterRule();
      }
      return val;

      //过滤规则：过滤不低于三个字符并相邻的重复字符串
      function filterRule() {
        var result = -1, //索引结果
          hasRepeat = false; //有重复的字符串
        for (var i = 0, num = 3; i + num * 2 <= val.length; i++) {
          result = val.indexOf(val.substr(i, num), i + num);
          if (result != -1) {
            if (i + num == result) {
              //相邻
              val = val.replace(val.substr(result, num), "");
              filterRule(); //递归过滤
              break;
            }
            hasRepeat = true;
            i--;
            num++;
            continue;
          }
          if (hasRepeat) {
            hasRepeat = false;
            num = 3;
          }
        }
      }
    },
  },
  computed: {
    // 给推广组件用的海报图链接 (当miniShareImgUrl 和 posterImg 同时有的时候 再赋值)
    posterImgForPromotion() {
      if (!this.vShowPoster || (this.isInApp && !this.miniShareImgUrl)) {
        return false;
      }
      return true;
    },

    roomDate() {
      if (
        !this.showDatePicker ||
        !this.checkInDate ||
        !this.checkOutDate ||
        !this.ticket ||
        this.ticket.selectEndDate == null ||
        this.ticket.selectStartDate == null
      ) {
        return false;
      }

      return (
        this.ticket.selectEndDate.index - this.ticket.selectStartDate.index
      );
    },

    // 是否展示推广员相关的推广信息
    showPromotion() {
      return (
        this.isPopularizer &&
        this.promotion &&
        !this.isShop &&
        !this.isOtherBrowsers
      );
    },

    // 是否展示推广员才能看到的信息
    showPopularizerMsg() {
      return (
        this.isPopularizer &&
        !this.isIOSReviewing &&
        !this.isTourist &&
        !this.isShop &&
        !this.isOtherBrowsers
      );
    },
  },
  watch: {
    showDatePicker(val) {
      if (!componentCenter.ticketCalendar) return;
      if (val) {
        this.ticket.useDate = componentCenter.ticketCalendar.calendar(
          this.ticket
        );
        if (!this.checkInDate && !this.checkOutDate) {
          const { checkInDate, checkOutDate } =
            this.getTodayAndTomorrowFormatted();
          this.checkInDate = checkInDate;
          this.checkOutDate = checkOutDate;
        }
        // componentCenter.ticketCalendar.seclectInOutDayByDate()
        // this.checkInDate = this.ticket.selectStartDate.sellDate;
        // this.checkOutDate = this.ticket.selectEndDate.sellDate;
      }
      if (this.checkInDate && this.checkOutDate) {
        componentCenter.ticketCalendar.seclectInOutDayByDate(
          this.checkInDate,
          this.checkOutDate
        );
      }
    },
  },
  methods: {
    ...productPoster,
    initSessionData() {
      if (sessionStorage.getItem("gd_pageData") && location.hash == "#gdFrom") {
        var option = JSON.parse(sessionStorage.getItem("gd_pageData")) || {};
        this.checkInDate = option.checkInDate;
        this.checkOutDate = option.checkOutDate;
        sessionStorage.removeItem("gd_pageData");
        history.go(-1);
      }
    },

    // 初始化特色介绍折叠
    initExpand() {
      this.$nextTick(() => {
        this.waitForImagesToLoad().then(() => {
          const height = this.$refs.buyNotesDetail.offsetHeight;
          // 判断特色介绍是否需要折叠
          if (height > window.innerHeight) {
            this.buyNotesExpand = false;
          } else {
            this.buyNotesExpand = true;
          }
        });

      })
    },

    expandBuyNotesDetailAll() {
      this.buyNotesExpand = true;
    },

    waitForImagesToLoad() {
      return new Promise((resolve) => {
        const images = this.$refs.buyNotesDetail.querySelectorAll('img');
        let loadedCount = 0;

        if (images.length === 0) {
          resolve(); // 没有图片，直接完成
          return;
        }

        images.forEach((img) => {
          if (img.complete) {
            loadedCount++;
            if (loadedCount === images.length) {
              resolve(); // 所有图片已加载完成
            }
          } else {
            img.onload = img.onerror = () => {
              loadedCount++;
              if (loadedCount === images.length) {
                resolve(); // 所有图片已加载完成或加载失败
              }
            };
          }
        });
      });
    },

    onImageLoad() {
      this.mySwiper.update();
    },



    //打开地图导航
    gotoNav: function () {
      var that = this;
      window.closeLocation = "0";
      window.initWeiXinSign();
      this.logHelpers({
        event_id: "520003",
        element_content: "clickAddress",
        cb: function () {
          gotoNavHelper();
        },
      });

      function gotoNavHelper() {
        if (that.isOtherBrowsers) {
          return;
        }
        if (that.isInApp) {
          that.callApp("showAddressMap", {
            params: {
              title: that.goodsDetails.hotelScenicName,
              address: that.goodsDetails.position,
              longitude: that.goodsDetails.longitude,
              latitude: that.goodsDetails.latitude,
            },
          });
          return;
        }

        ///TLH220921

        openLocation({
          latitude: that.goodsDetails.latitude,
          longitude: that.goodsDetails.longitude,
          name: that.goodsDetails.hotelScenicName, // 位置名
          address: that.goodsDetails.position, // 地址详情说明
        });
      }
    },

    // 获取今天和明天的日期，格式为YYYY-MM-DD
    getTodayAndTomorrowFormatted() {
      // 获取今天的日期
      let today = new Date();
      // 获取明天的日期
      let tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      // 格式化日期为YYYY-MM-DD
      function formatDate(date) {
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2); // 月份是从0开始的
        const day = ("0" + date.getDate()).slice(-2);
        return year + "-" + month + "-" + day;
      }

      // 格式化今天和明天的日期
      const checkInDate = formatDate(today);
      const checkOutDate = formatDate(tomorrow);
      return { checkInDate, checkOutDate };
    },

    //显示酒景推广或分享弹框
    showScenicPromotion: function () {
      this.logHelpers({
        event_id: "520017",
      });
      YCF_Plugin.anchorPoint(
        "酒景页下面的分享",
        "productdetail_down_share",
        `scenicId:${this.scenicId}`
      );
      window.componentCenter.productPromotion.showShare(this);
    },

    // 获取app海报图数组
    getAppPosters: function (posterImg, coverImg, photos) {
      var result = posterImg ? [].concat(posterImg) : [],
        photoList = photos ? [].concat(photos) : [];

      if (coverImg) {
        photoList.unshift(coverImg);
      }

      if (photoList.length > 10) {
        photoList.length = 10;
      }
      result = result.concat(photoList);
      return result;
    },

    // 跳到购买须知
    goBuyNote: function () {
      $(".content").animate(
        {
          scrollTop: $("#buy-notes")[0].offsetTop,
        },
        500
      );
    },

    //商品详情弹窗
    goRoomDetail: function (good, isActivity) {
      var cateId = parseInt(good.cateId);
      var that = this;
      if (cateId === 9 || cateId === 6) {
        var options = {
          goodId: good.goodId,
          skuId: good.skuId,
          title: "商品说明",
          showBookNotice: true,
          showBottom: true,
          price: good.activityPrice,
          oriPrice: good.originalPrice,
          fn_book: function () {
            if (that.isInApp && window.isTourist) {
              console.log("游客身份,需要先登录");
              that.goAppLogin();
              return false;
            }
            // 兼容奖励上浮
            that.storgeDate();
            that.goHelper(
              "/front/index/roomReserve?" +
              toQueryString({
                weChatId: good.weChatId,
                goodId: good.goodId,
                skuId: good.skuId,
                checkInTime: that.checkInDate || "",
                checkOutTime: that.checkOutDate || "",
                activityId: good.activityId || "",
              })
            );
          },
          btnText: isActivity ? "立即抢购" : "立即预订",
          btnClass: "",
          isNeedSetHash: true,
          item: {},
          equalPrice: !!(that.roomDate && that.roomDate > 1),
        };
        if (!good.timeStockNum) {
          options.btnText = "满房";
          options.btnClass = "disabled";
        }
        window.componentCenter.roomDetail.showDialogRoomDetail(options);

        // 大数据锚点
        // 这个是酒景点击产品项的锚点
        this.logHelpers({
          event_id: "500078",
          event_content: {
            good_id: good.goodId,
            pos: good.isActivity ? 1 : 2,
            channel_id: window.sessionStorage.getItem("channel_ref") || "",
          },
        });
        // 这是进入产品详情页的锚点
        this.logHelpers({
          event_id: "500004",
          item_id: good.goodId,
          channel_id: sessionStorage.getItem("channel_ref") || "",
        });
      } else {
        that.goProductDetails(good, { isBook: true });
      }
    },

    // android 长按保存图片
    saveImage: function () {
      if (window.mobileEnv == "app" && isAndroid() && ykzApp.saveImage) {
        pressEvent("body", "img", (e) => {
          let src = e.target.src;
          if (src.search(/^http/) == -1) {
            //相对路径补全链接
            src = location.protocol + "//" + location.hostname + src;
          }
          ykzApp.saveImage(src);
        });
      }
    },

    // 回到顶部
    scrollToTop: function () {
      $(".content").scrollTop(1);
    },

    // 显示奖励弹窗
    showCommissionPopUp: function (good) {
      window.componentCenter.incomeStatement.slideUpIncomeStatement(
        this.getCommission(good)
      );
    },

    // 奖励弹窗文案
    getCommission: function (good) {
      return {
        goodId: good.goodId,
        sellComm:
          (good.activityStatus == 1
            ? good.wechatSaleCommission
            : good.sellComm) || "", // 页面展示的奖励
        appSellComm:
          (good.activityStatus == 1
            ? good.appSaleCommission
            : good.appSellComm) || "",
        goodSellComm:
          good.activityStatus == 1
            ? good.goodwechatSaleCommission
            : good.goodsellComm,
        goodAppSellComm:
          good.activityStatus == 1
            ? good.goodappSaleCommission
            : good.goodappSellComm,
        agencyComm: good.agencyComm || "",
        originalSellComm:
          (good.activityStatus == 1
            ? good.originalwechatSaleCommission
            : good.originalsellComm) || "", // 不加推广奖励的奖励
        originalAppSellComm:
          (good.activityStatus == 1
            ? good.originalappSaleCommission
            : good.originalappSellComm) || "",
        appAgencyComm: good.appAgencyComm || "",
        commReturnType: good.commReturnType || "",
        isOpenMemberCommission: good.isOpenMemberCommission || 0,
        isMultipleCommission: good.isMultiPrice,
        isAppMultipleCommission: good.isMultiPrice,
        memberLevel: this.promoter.memberLevel,
        memberReward: this.promoter.memberReward,
        sellCommFriends: this.promoter.sellCommFriends,
        isNewPromoter: this.promoter.isNewPromoter,
        hasTeamPrivilege: this.promoter.hasTeamPrivilege,
        isHaveFans: this.promoter.isHaveFans,
        price: good.activityPrice || "",
        goodComm: good.goodComm || "",
        isExcellence: this.promoter.isExcellence || 0,
        nowLevelSellComm: good.promoterLevel.nowLevelSellComm,
        nowLevelAgencyComm: good.promoterLevel.nowLevelAgencyComm,
        toLevelNoString: good.promoterLevel.toLevelNoString,
        nowLevelNo: good.promoterLevel.nowLevelNo,
        toLevelSellComm: good.promoterLevel.toLevelSellComm,
        toLevelAgencyComm: good.promoterLevel.toLevelAgencyComm,
      };
    },
    // 初始化
    initCopyPassword: function () {
      var that = this;
      YCF_Plugin.createPassword(this.getPassword())
        .success(function (res) {
          that.password = res;
        })
        .fail(function () {
          that.loadPasswordError = true;
        });
    },
    // 获取口令
    getPassword: function () {
      var password;

      password = {
        procuctImg:
          this.goodsDetails.coverImg ||
          this.goodsDetails.poster ||
          window.comm.hotelImg ||
          window.comm.hotelImg.defaultHotelImg,
        productTitle:
          this.goodsDetails.hotelScenicName +
          (this.goodsDetails.description
            ? "-" + this.goodsDetails.description
            : ""),
        guideText: this.goodsDetails.hotelScenicName,
        price: this.getMinPrice(),
        commission: "¥" + (this.appSellComm ? this.appSellComm : this.sellComm),
        productUrl: updateUrlParam(
          window.location.href,
          "scenicFrom",
          "appCommand"
        ),
      };
      return password;
    },

    // 拿最小价格
    getMinPrice: function () {
      var priceList = [this.activityGoodsList, this.commonGoodsList],
        minPrice;

      priceList.forEach(function (arr) {
        arr.forEach(function (obj) {
          obj.list.forEach(function (item) {
            if (item.activityPrice < minPrice || !minPrice) {
              minPrice = item.activityPrice;
            }
          });
        });
      });
      return minPrice || 0;
    },

    callApp: function (method, opt) {
      opt = opt || {};
      ykzApp.ready(function () {
        if (ykzApp[method]) {
          if (opt.params) {
            ykzApp[method](opt.params);
          } else {
            ykzApp[method]();
          }
          opt.suc_cb && opt.suc_cb();
        } else {
          if (opt.fail_cb) {
            opt.fail_cb();
          } else {
            toast("APP版本过低，请更新到最新版本重试！");
          }
        }
      });
    },

    // 处理返回事件
    handleHash() {
      if (
        location.hash == "#incomeStatement" ||
        location.hash == "#roomDetails" ||
        location.hash == "#scenicPromotion" ||
        location.hash == "#calendar" ||
        location.hash == "#shareType" ||
        location.hash == "#buyTips"
      ) {
        history.go(-1);
      }
      window.onhashchange = function () {
        if (!location.hash) {
          componentCenter.incomeStatement.showIncomeStatement &&
            componentCenter.incomeStatement.slideDownIncomeStatement();
          componentCenter.roomDetail.dialogRoomDetailShowed &&
            componentCenter.roomDetail.hideDialogRoomDetail();
          componentCenter.productPromotion.showProductPromotion &&
            componentCenter.productPromotion.slideDownProductPromotion();
          componentCenter.shareType &&
            componentCenter.shareType.showShareType &&
            componentCenter.shareType.slideDownShareType();
          componentCenter.ticketCalendar.showCalendar &&
            componentCenter.ticketCalendar.slideDownCalendar();
        }
      };
    },

    logHelpers: function (opt) {
      opt = opt || {};
      if (!opt.event_id) {
        return false;
      }

      var event_content = $.extend(
        true,
        {},
        {
          item_id: opt.item_id || this.scenicId,
          scenic_id: this.scenicId,
          scenicFrom: getUrlParams("scenicFrom") || "",
          element_content: opt.element_content || "",
        },
        opt.event_content || {}
      );
      YCF_Plugin.reportUserAnchors(
        {
          event_id: opt.event_id,
          event_content: event_content,
          page_name: "酒景详情页",
          platForm: sessionStorage.getItem("isOtherBrowsers_platForm") || "",
        },
        {
          logChannel: true,
        }
      ).always(function () {
        opt.cb && opt.cb();
      });
    },

    showAvatarOptions() {
      this.logHelpers({
        event_id: "500125",
      });
    },

    getCommentInfos(commet) {
      if (Object.keys(commet).length == 0) return;
      this.commentInfos = commet;
      this.commentInfos.commentCount = commet.count;

    },

    // 调起日历组件
    pickDate() {
      var inDate = this.checkInDate || "",
        outDate = this.checkOutDate || "";

      if (inDate && outDate) {
        componentCenter.ticketCalendar.seclectInOutDayByDate(inDate, outDate);
      }

      componentCenter.ticketCalendar.loadCalendar(
        () => {
          this.checkInDate = this.ticket.selectStartDate.sellDate;
          this.checkOutDate = this.ticket.selectEndDate.sellDate;
          cb.bind(this)();
        },
        () => {
          this.checkInDate = "";
          this.checkOutDate = "";
          cb.bind(this)();
        }
      );

      this.logHelpers({
        event_id: "520003",
        element_content: "ClickCheckTime",
      });

      function cb() {
        return new Promise((resolve, reject) => {
          this.ajaxGetGoodsList(resolve, reject);
        }).then(() => {
          return new Promise(() => {
            // 拿奖励
            this.handleSortList(this.activityGoodsList);
            this.handleSortList(this.commonGoodsList);
            // 拿绑定的下单任务
            this.getBindOrderTask();
          });
        });
      }
    },

    // 更新时间段库存
    updateTimeStockNum(data) {
      var dataList = [data.activityGoodsList, data.commonGoodsList],
        orlList = [this.activityGoodsList, this.commonGoodsList],
        goodsAll = [],
        goods,
        index;

      dataList.forEach((item) => {
        item.forEach((citem) => {
          goods = citem.list;
          goodsAll = goodsAll.concat(goods);
        });
      });

      orlList.forEach((list) => {
        list.forEach((item) => {
          if (item.list && item.list.length > 0) {
            item.list.forEach((citem) => {
              index = this.getIndexBy(goodsAll, "goodId", citem.goodId);
              if (index > -1) {
                citem.timeStockNum = goodsAll[index].timeStockNum;
              }
            });
          }
        });
      });
    },

    // 通过key获取index
    getIndexBy(result, key, value) {
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i][key] == value) {
          return i;
        }
      }
      return -1;
    },

    // 兼容奖励上浮
    storgeDate() {
      if (
        this.checkInDate &&
        this.checkOutDate &&
        this.checkInDate != getUrlParams("checkInDate") &&
        this.checkOutDate != getUrlParams("checkOutDate")
      ) {
        sessionStorage.setItem(
          "gd_pageData",
          JSON.stringify({
            checkInDate: this.checkInDate,
            checkOutDate: this.checkOutDate,
          })
        );
        this.setHash("gdFrom");
      }
    },

    //设置hash值
    setHash(str) {
      if (location.hash.replace("#", "") != str) {
        location.hash = str;
      }
    },
    // .............................................. 页面交互相关 end ..............................................

    // .............................................. 奖励上浮倒计时相关 end ..............................................
    initCountDown() {
      var list = this.floatCommList,
        commTextObj;
      if (list.length <= 0) {
        return;
      }

      setInterval(() => {
        list.forEach((item) => {
          commTextObj = handleGoodsHighCommText.bind(this)(item);
          item.highCommissionText = commTextObj.text;
          item.activityStatus = commTextObj.status;
        });
        this.$forceUpdate();
      }, 100);

      // return {text: '限时奖励提示文案', status: 0,1,2 0未开始，1进行中,2已结束}
      function handleGoodsHighCommText(goods) {
        var text = "",
          h = "",
          m = "",
          timeDiff = 0,
          now = new Date().getTime() + this.commDiffTime,
          status = 0;

        if (now > goods.endTimeCountDown) {
          // 已结束
          return {
            text,
            status: 2,
          };
        }

        if (now < goods.startTimeCountDown) {
          // 未开始
          timeDiff = goods.startTimeCountDown - now;
          status = 0;
        } else {
          // 进行中
          timeDiff = goods.endTimeCountDown - now;
          status = 1;
        }

        h = Math.floor(timeDiff / (1000 * 60 * 60));
        m = Math.ceil((timeDiff - h * (1000 * 60 * 60)) / (1000 * 60));

        if (status == 0) {
          // 活动开始前20分钟显示该气泡
          if (timeDiff >= 20 * 60 * 1000) {
            text = "";
          } else {
            text = `${h}时${m}分后上浮至<span class="high-light">${goods.highCommission}</span>`;
          }
        } else {
          text = `${h}时${m}分后恢复<span class="high-light">${goods.appSellComm || goods.sellComm
            }</span>`;
        }

        return {
          text,
          status,
        };
      }
    },
    // .............................................. 奖励上浮倒计时相关 end ..............................................

    // .............................................. 接口相关 ..............................................

    // 设置微信分享
    setShare: function () {
      var that = this,
        shareObj = {
          imgUrl:
            that.goodsDetails.coverImg ||
            that.goodsDetails.poster ||
            window.comm.hotelImg ||
            window.comm.hotelImg.defaultHotelImg,
          descContent: this.isShop
            ? "精选特价限时抢购，快来看看吧"
            : window.descContent,
          lineLink: location.href,
          shareTitle: that.goodsDetails.hotelScenicName,
          channel: "wechat#wechattimeline#miniprogram#copylink#qq#sweibo",
          anchorData: {
            item_id: that.scenicId || "",
            type: "scenic",
            activity_id: that.activityId || "",
            source: "scenic",
          },
        };
      shareObj.lineLink = updateUrlParam(shareObj.lineLink, "securityKey", "");
      shareObj.lineLink = updateUrlParam(shareObj.lineLink, "checkIn", "");
      shareObj.lineLink = updateUrlParam(shareObj.lineLink, "checkOut", "");
      window.defShareObj = shareObj; //覆盖头像浮层组件的微信分享
      that.shareObjLink = shareObj.lineLink;

      getUserPromotion().then(function (promotion) {
        if (promotion) {
          shareObj.lineLink = updateUrlParam(
            shareObj.lineLink,
            "promotion",
            promotion
          );
          that.promotion = promotion;
          that.shareObjLink = shareObj.lineLink;
        }

        // 小程序分享 + 配置app分享
        if (isYkzMiniprogram() || that.isInApp) {
          that.shareObj = shareObj;
          that.setYkzMiniprogramShare();
        } else {
          YCF_Plugin.setWeiXinShare(shareObj, promotion);
        }

        // 设置分享链接给短链接组件
        that.shortShareLink = updateUrlParam(
          shareObj.lineLink,
          "scenicFrom",
          "shortUrl"
        );
        // 设置短链接的分享文案
        that.shortShareTxt =
          that.goodsDetails.hotelScenicName +
          (that.goodsDetails.description
            ? "-" + that.goodsDetails.description
            : "");
      });
    },

    // 设置小程序分享
    setYkzMiniprogramShare: function () {
      this.shareObj.miniShareTitle = this.goodsDetails.hotelScenicName;
      this.shareObj.miniShareImgUrl = this.goodsDetails.showCoverImg;
      this.shareObj.shareInMini = true;
      this.getScienceSharePic()
        .then((imgUrl) => {
          this.shareObj.miniShareImgUrl = imgUrl;
        })
        .finally(() => {
          YCF_Plugin.setWeiXinShare(
            JSON.parse(JSON.stringify(this.shareObj)),
            this.promotion
          );
        });
    },

    // 获取酒景小程序分享图
    getScienceSharePic: function () {
      var that = this;
      return new Promise(function (resolve, reject) {
        if (that.miniShareImgUrl) {
          resolve(that.miniShareImgUrl);
          return;
        }

        that
          .ajaxGetSharePic({
            scenicId: that.scenicId,
            type: getUrlParams("showAllWechat") || "",
            formWechatId: that.cWechat == 421 ? 421 : "",
          })
          .then(
            function (imgUrl) {
              that.miniShareImgUrl = imgUrl;
              resolve(that.miniShareImgUrl);
            },
            function (err) {
              reject(err);
            }
          );
      });
    },

    //判断当前用户是否推广员，并获取相关信息
    ajaxGetUserInfo: function (resolve, reject) {
      var that = this;
      verifyPopularizer()
        .then(function (_ajaxResult) {
          isPopularizer(_ajaxResult);
          resolve(_ajaxResult);
        })
        .catch(function () {
          reject();
        })
        .finally(function () {
          reject();
        });

      function isPopularizer(ajaxResult) {
        that.isPopularizer = 1;

        // app下并且是游客身份表示为未登录
        if (that.isInApp && that.isTourist) {
          that.isPopularizer = 0;
        }
        // that.isTourist = false; //不知为何要加这
        that.promoter = ajaxResult.content || {};
      }
    },

    // 获取商品详情
    ajaxGetGoodsDeatail(resolve, reject) {
      const extendObj = !openApiGood
        ? { url: "/apiv2/hotel/scenicDetail" }
        : {};

      Databus({
        url: "/api/scenic/scenicDetail",
        data: {
          scenicId: this.scenicId,
          isShop: this.isShop,
        },
        type: "GET",
        origin: Origins.API_GOOD,
        success: (data) => {
          if (data.code === 1000 && data.bcode === 100) {
            const { content } = data;
            this.goodsDetails = content;
            this.swiperNumber = content.photoNumber;

            this.vShowPoster = !!content.poster;
            if (content.averageRate) {
              content.averageRate *= 1;
            }

            if (content.graphic) {
              this.handleImgTxt(content.graphic)
              /*
              this.goodsDetails.graphic = lazyWithStr(content.graphic);
              this.initExpand();

              this.$nextTick(() => {
                $("img.lazy").lazyload({
                  effect: "fadeIn",
                  container: $(".page"),
                });
              })
              */  
            }

            if (content.coverImg) {
              this.swiperNumber++;
              if (content.album) content.album.unshift(content.coverImg);
            }



            // 商品推荐1.3需求 2019-10-17
            const { cityName, cityCode, districtName, districtCode } = content;
            this.promotionCity = { cityName, cityCode, districtName, districtCode };
          }

          this.timestamp = data && data.timeStamp;
          this.setShare();
          resolve(data);
        },
        error: reject,
        ...extendObj,
      });
    },


    async handleImgTxt(rawInput) {
     
      var ls =  lazyWithStr(rawInput,);

      const imgTxtFormated = await lolila_2_nanuli_core(ls, true,400);
      this.imgTxtFormated = imgTxtFormated
      this.initExpand();
      this.$nextTick(() => {
        $("img.lazy").lazyload({
          effect: "fadeIn",
          container: $(".page"),
        });
      })
      
    },



    // 获取相册列表
    fetchOfficialAlbum() {
      Databus({
        type: 'get',
        url: '/apiv2/Room/videoandpic',
        data: {
          hotelScenicId: this.scenicId || '',
        },
        success: (res) => {
          const { code, bcode, content } = res;
          if (code === 1000 && bcode === 100 && content) {
            const newList = content.list.filter((v) => v.isShow == 1);

            // 构造 officialTabs 和 officialAlbum
            const officialTabs = newList.map((item) => ({
              isShow: item.isShow,
              label: item.detailTitle,
              total: item.total || 0,
              tagId: item.tagId,
              switchTab: 'official'
            }));

            // 构造 bannerList：保证视频在前，图片在后
            let videoList = [];
            let imageList = [];

            newList.forEach((item) => {
              if (item.list && item.list.length) {
                item.list.forEach((v) => {
                  let banner = { tagId: item.tagId, switchTab: 'official' };
                  if (v.isVideo) {
                    banner.coverUrl = `${v.coverUrl}?imageView2/2/interlace/1/q/85`;
                    banner.url = v.url;
                    banner.type = 'video';
                    banner.group = item.detailTitle
                    videoList.push(banner);  // 视频放到视频列表中
                  } else {
                    if (v.roomImageList && v.roomImageList.length) {
                      // 床型
                      v.roomImageList.forEach(room => {
                        if (!room.isVideo) {
                          banner.group = room.imageTag
                          banner.url = room.url + '?imageView2/2/interlace/1/q/85';
                          banner.type = 'image';
                          imageList.push(banner);  // 图片放到图片列表中
                        }

                      })
                    } else {
                      banner.group = item.detailTitle
                      banner.url = v.url + '?imageView2/2/interlace/1/q/85';
                      banner.type = 'image';
                      imageList.push(banner);  // 图片放到图片列表中
                    }


                  }
                });
              }
            });



            // 将视频列表和图片列表合并，视频优先
            this.bannerList = [...videoList, ...imageList];
            this.initSwiper()



            // 设置视频自动播放 / 微信h5兼容很差暂时去掉自动播放功能
            // if (autoPlay === '1') {
            //   this.autoPlay = true;
            //   this.showStartBtn = false;
            // } else {

            // }
            // 视频独有
            this.$nextTick(() => {
              this.showStartBtn = true;
              this.showCoverImg = true;
            })
            // 更新导航栏
            this.navList = officialTabs;

            // console.log(this.bannerList, '轮播图');
          }
        },
        error: () => {
          hideLoading();
        }
      });
    },

    // 攻略列表
    getGuideList(list) {
      // 获取游客实拍
      this.fetComments().then(() => {
        this.setStrategyNav(list);  // 设置攻略导航
      })
    },

    setStrategyNav(list) {
      if (!list || !list.length) return
      // const { cover, title } = this.strategyList[0];
      // if (!cover) return;
      // this.bannerList.push({
      //   url: `${cover}?imageView2/2/interlace/1/q/85`,
      //   type: 'strategy',
      //   group: '游玩攻略',
      //   title,
      //   tagId: 'strategy'
      // });
      this.navList.push({
        switchTab: 'strategy',
        label: '游玩攻略',
        tagId: null
      })
    },


    // 获取游客实拍
    fetComments() {
      return new Promise((resolve) => {
        Databus({
          type: 'get',
          url: '/apiv2/goodscomment/getList',
          data: {
            hotelScenicId: this.scenicId,
            tagId: 2, // 写死了 获取有照片的评论
            page: 1,
            pageSize: 1
          },
          success: res => {
            const { code, bcode, content } = res;
            if (code == 1000 && bcode == 100 && content) {
              if (content.list && content.list.length) {
                // const { createTime, imageUrls } = content.list[0];

                // const formatTimestampToYearMonth = (timestamp) => {
                //   const date = new Date(timestamp * 1000); // 转换为毫秒
                //   const year = date.getFullYear();
                //   const month = date.getMonth() + 1; // getMonth() 返回 0-11，所以 +1
                //   return `${year}年${month}月`;
                // }

                // if (imageUrls && imageUrls.length) {
                // this.bannerList.push({
                //   url: `${imageUrls[0]}?imageView2/2/interlace/1/q/85`,
                //   type: 'tourist',
                //   group: '游客实拍',
                //   createTime: formatTimestampToYearMonth(createTime),
                //   tagId: 'yksp'
                // })
                // 增加轮播导航
                this.navList.push({
                  switchTab: 'tourist',
                  label: '游客实拍',
                  tagId: null
                })


                // }
              }
            }


          },
          complete: () => {
            resolve();
          }
        });
      });
    },


    // 初始化轮播图
    initSwiper() {

      // 判断最后一张是左滑还是右滑
      const isRight = (dx, dy) => {
        let angle = (Math.atan2(dy, dx) * 180) / Math.PI;
        if (
          (angle >= 135 && angle <= 180) ||
          (angle >= -180 && angle < -135)
        ) {
          return true;
        }
        return false;
      }


      let startX = 0;
      let startY = 0;


      this.$nextTick(() => {
        this.mySwiper = new Swiper("#swiper", {
          ...this.swiperOptions,
          onInit: () => {

            console.log('swiper init');
          
          },
          onSlideChangeStart: (swiper) => {

            this.bannerIndex = swiper.activeIndex;
            this.onSlideChangeStart(swiper);

          },
          onTouchStart: function (swiper, event) {
            if (event.type === "touchstart") {
              startX = event.touches[0].pageX;
              startY = event.touches[0].pageY;
            }
          },
          onTouchEnd: (swiper, event) => {
            if (event.type === "touchend") {
              let endX = event.changedTouches[0].pageX;
              let endY = event.changedTouches[0].pageY
              const dx = endX - startX
              const dy = startY - endY;
              // 最后一张直接进入相册
              if (this.bannerList.length == this.bannerIndex + 1 && isRight(dx, dy)) {
                // 跳到第一个tag
                // this.toAlbum(this.bannerList[0].tagId || '', 'official')
              }
            }
          },
        });



      });
    },

    onSlideChangeStart(swiper) {

      // 最后一张直接进入相册
      if (this.bannerList.length == this.bannerIndex + 1) {
        // 跳到第一个tag
        // this.toAlbum(this.bannerList[0].tagId || '', 'official')
      }

      this.$nextTick(() => {

        const tagId = this.bannerList[this.bannerIndex].tagId;
        const targetElement = document.querySelector(`.nav-item-localtion${tagId}`);
        if (targetElement) {
          const container = document.querySelector('.nav-bar-left'); // 包裹横向滚动的容器
          if (container) {
            // 计算目标元素的左侧偏移量，并设置容器的 scrollLeft 值
            const offsetLeft = targetElement.offsetLeft - container.offsetLeft;
            const extraOffset = 20; // 调整偏移量，值可根据需求调整

            container.scrollTo({
              left: offsetLeft - extraOffset, // 加上额外偏移量
              behavior: 'smooth', // 平滑滚动
            });
          }
        }

        this.updateSwiper();
      });
    },
    onSlideChangeEnd(swiper) {
      // console.log('onSlideChangeEnd', swiper);
    },

    // banner导航栏切换
    changeNav(value, switchTab) {
      if (value) {
        const index = this.bannerList.findIndex(v => v.tagId == value);
        this.bannerIndex = index;
        this.mySwiper.slideTo(index, 100);
      } else {
        this.toAlbum(value, switchTab);
      }


    },

    // 图片/视频预览
    previewImg(url) {

      // console.log(this.bannerList, 'this.bannerList');
      this.mediaList = this.bannerList;
      this.isPreviewVisible = true;
    },

    toAlbum(value, switchTab) {

      const url = "/front/platform/newPlatformAlbum?" +
        toQueryString({
          weChatId: this.weChatId,
          fromWeChatId: this.fromWeChatId,
          hotelScenicId: this.scenicId,
          switchTab: switchTab,
          tagId: value
        });

      location.href = url;
    },
    //  ********* 轮播视频 start *******************
    updateSwiper() {
      if (this.mySwiper) {
        this.mySwiper.update(); // 仅更新 Swiper 容器
        this.mySwiper.updateAutoHeight();

      }
    },
    // video实例
    onReady(player) {
      this.xgplayer = player;

      console.log('video就绪');
    },

    // 播放ICON
    handlePlay() {
      this.xgplayer.play()


    },
    // 暂停ICON
    handleStop() {
      this.xgplayer.pause()
    },

    // 暂停callback
    changePause() {
      this.showStartBtn = true;
      this.showStopBtn = false;

      this.updateSwiper();
    },
    // 播放callback
    changePlay() {
      this.showStartBtn = false;
      this.showStopBtn = true;
      this.showCoverImg = false;
      setTimeout(() => {
        this.updateSwiper();
      }, 50);
    },
    // 视频聚焦
    changeFocus() {
      this.showStopBtn = !this.showStopBtn;
    },
    // 视频失焦
    changeBlur() {
      this.showStopBtn = !this.showStopBtn;
    },

    // ********* 轮播视频 end *******************

    onSwiperImageLoad(event, url) {
      const imgElement = event.target; // 当前加载的图片元素
      const container = imgElement.closest(".swiper-image-wrap"); // 当前图片的父容器
      if (!container) {
        console.warn("未找到父容器");
        return;
      }

      const imageWidth = imgElement.naturalWidth;
      const imageHeight = imgElement.naturalHeight;
      const containerWidth = container.offsetWidth;

      const actualHeight = (imageHeight / imageWidth) * containerWidth;

      // 只修改当前容器的高度
      if (actualHeight < containerWidth * (1 / 2)) {
        container.style.height = `${containerWidth}px`;
      } else {
        container.style.height = `${actualHeight}px`;
      }

      this.updateSwiper();

      // console.log(`当前容器修改为: ${container.style.height}`);
    },

    //获取商品列表
    ajaxGetGoodsList: function (resolve, reject) {
      let that = this,
        extendObj = {};
      if (!openApiGood) {
        extendObj = {
          url: "/apiv2/room/getScenicGoods",
        };
      }

      Databus({
        url: "/api/scenic/getScenicGoods",
        data: {
          scenicId: that.scenicId,
          type: getUrlParams("showAllWechat") || "",
          formWechatId: that.cWechat == 421 ? 421 : "",
          checkInTime: this.checkInDate,
          checkOutTime: this.checkOutDate,
          isShop: this.isShop,
        },
        type: "GET",
        origin: Origins.API_GOOD,
        success: (data) => {
          if (data.code === 1000 && data.bcode === 100 && data.content) {
            that.activityGoodsList = that.handleGoodsList(
              data.content.activityGoodsList
            );
            that.commonGoodsList = that.handleGoodsList(
              data.content.commonGoodsList
            );
            if (
              that.activityGoodsList.length == 0 &&
              that.commonGoodsList.length == 0
            ) {
              that.vShowEmptyGood = true;
            }
            that.mergeList = that.handleMergeList();
          } else {
            toast(data.message || "获取商品信息有误，请刷新重试");
          }
          return resolve();
        },
        error: function () {
          return reject();
        },
        ...extendObj,
      });
    },

    // 处理goodsList
    handleGoodsList: function (list) {
      var that = this;
      function handleSublist(goodsList) {
        var cateId, good;
        if (goodsList && goodsList.length && goodsList.length > 0) {
          for (var i = 0, length = goodsList.length; i < length; i++) {
            good = goodsList[i];
            cateId = good.cateId;

            // 过滤后台返回的没用的cateId
            if (cateId) {
              cateId = parseInt(cateId);
              if (cateId == cateId) {
                good.valueableCateId = true;
              } else {
                good.valueableCateId = false;
              }
            } else {
              good.valueableCateId = false;
            }

            // 加上锚点参数
            good.anchors = JSON.stringify({
              item_id: good.goodId,
              product_category: "product",
            });

            // 加上是否微客房
            good.isMiniRoom = cateId == 6 || (cateId == 9 && !good.isActivity);
            if (
              !that.showDatePicker &&
              (cateId == 9 || cateId == 6) &&
              good.isCalendar
            ) {
              that.showDatePicker = true;
            }

            // 微客房-原价小于0.1的不展示
            if (good.isMiniRoom && good.originalPrice < 0.1) {
              good.originalPrice = 0;
            }

            // 常规微客房兼容
            if (good.cateId == 9 && !good.isActivity) {
              good.goodsAlias = good.goodsName;
            }

            good.isShowOriginalPrice = true;

            if (!that.isInApp && good.addPrice && good.addPrice != 0) {
              let wxActivityPrice =
                parseFloat(good.addPrice) + parseFloat(good.activityPrice);
              good.wxActivityPrice = wxActivityPrice.toFixed(2);
              if (+good.originalPrice <= +wxActivityPrice) {
                good.isShowOriginalPrice = false;
              }
            } else if (+good.originalPrice <= +good.activityPrice) {
              good.isShowOriginalPrice = false;
            }
          }
        }
      }

      if (list && list.length && list.length > 0) {
        for (var i = 0, length = list.length; i < length; i++) {
          handleSublist(list[i].list);
        }
      }
      return list;
    },

    // 生成所有产品列表
    handleMergeList() {
      const list1 = this.activityGoodsList,
        list2 = this.commonGoodsList;

      let arr = [];
      for (let i = 0, len1 = list1.length; i < len1; i++) {
        const goods = list1[i].list;
        arr = arr.concat(goods);
      }

      for (let j = 0, len2 = list2.length; j < len2; j++) {
        const goods = list2[j].list;
        arr = arr.concat(goods);
      }
      return arr;
    },

    // 获取奖励
    ajaxGetExtendGoods: function (resolve, reject) {
      var that = this,
        goodId = that.getGoodId();

      if (goodId.length < 1) return false;

      var now = new Date().getTime();
      Databus({
        url: "/apiv2/marketing/getExtendGoods",
        data: {
          goodId: goodId,
        },
        type: "POST",
        success: function (data) {
          if (data.code === 1000 && data.bcode === 100) {
            for (var i = 0; i < data.content.length; i++) {
              that.promotionProduct[data.content[i].goodsId] = data.content[i];
            }
            this.commDiffTime = data.timeStamp * 1000 - now;
          }
          return resolve();
        },
        error: function () {
          toast("网络有误，获取奖励信息失败，请刷新重试");
          return reject();
        },
      });
    },

    // 获取奖励接口参数 goodId
    getGoodId: function () {
      var list = this.mergeList,
        goodId = [];

      for (var i = 0, length = list.length; i < length; i++) {
        goodId.push(list[i].goodId);
      }
      return goodId;
    },

    //活动是否开始
    isActivityStart: function (startTime) {
      return parseInt(startTime) < parseInt(this.timestamp);
    },

    handleSortList: function (list) {
      for (var i = 0, len = list.length; i < len; i++) {
        this.handlePromote(list[i].list);
      }
    },

    //处理产品奖励 + 处理海报是否显示
    handlePromote: function (goodList) {
      for (var i = 0; i < goodList.length; i++) {
        var good = goodList[i];
        var promotionProduct = this.promotionProduct[good.goodId];
        if (promotionProduct) {
          var sellComm = this.getComm(promotionProduct.sellComm, good);
          if (sellComm > 0 || promotionProduct.commType === "1") {
            Vue.set(good, "sellComm", promotionProduct.sellComm);
          }
          var agencyComm = this.getComm(promotionProduct.agencyComm, good);
          if (agencyComm > 0 || promotionProduct.commType === "1") {
            Vue.set(good, "agencyComm", promotionProduct.agencyComm);
          }
          var appSellComm = this.getComm(promotionProduct.appSellComm, good);
          if (appSellComm > 0 || promotionProduct.commType === "1") {
            Vue.set(good, "appSellComm", promotionProduct.appSellComm);
          }
          var appAgencyComm = this.getComm(
            promotionProduct.appAgencyComm,
            good
          );
          if (appAgencyComm > 0 || promotionProduct.commType === "1") {
            Vue.set(good, "appAgencyComm", promotionProduct.appAgencyComm);
          }
          var goodComm = this.getComm(promotionProduct.goodComm, good);
          if (goodComm > 0 || promotionProduct.commType === "1") {
            Vue.set(good, "goodComm", promotionProduct.goodComm);
          }
          Vue.set(
            good,
            "isOpenMemberCommission",
            promotionProduct.isOpenMemberCommission
          );
          Vue.set(good, "promoterLevel", promotionProduct.promoterLevel || {});
          this.addHighComm(promotionProduct, good);
          this.commAddgoodComm(good);
        }

        // 处理海报是否显示
        this.handlePosterVisible(good);
      }
    },

    //推广奖励增加推广奖励, 这里要算 给奖励弹窗用
    commAddgoodComm(comm) {
      var commKeys = ["sellComm", "appSellComm"],
        goodCommNum = 0;

      if (comm.highCommission) {
        commKeys = commKeys.concat([
          "wechatSaleCommission",
          "appSaleCommission",
        ]);
      }

      if (
        typeof comm == "object" &&
        comm.goodComm &&
        typeof comm.goodComm == "string"
      ) {
        goodCommNum = +comm.goodComm.replace(/[^0-9|.]/g, "") || 0; //推广奖励提取的浮点数
      }

      commKeys.forEach((item) => {
        var num =
          (typeof comm[item] == "string" &&
            +comm[item].replace(/[^0-9|.]/g, "")) ||
          0;
        // 不加推广奖励的奖励
        comm[`original${item}`] = comm[item] || "";

        // 加了推广奖励的奖励
        comm[`good${item}`] = (num + goodCommNum).toFixed(2);

        // 页面展示的奖励
        //comm[item] = this.promoter.isExcellence && goodCommNum ? comm[`good${item}`] : num;
        comm[item] = comm[`good${item}`];

        if (comm[`original${item}`]) {
          if (comm[`original${item}`].search("%") != -1) {
            comm[item] += "%";
          } else {
            comm[item] = "￥" + comm[item];
          }
        }
      });
    },

    // 增加限时奖励上浮参数
    addHighComm(promotionProduct, good) {
      // 新增奖励上浮参数
      if (promotionProduct.isHaveHighCommission) {
        var keys = [
          "highCommission",
          "wechatSaleCommission",
          "appSaleCommission",
        ];
        keys.forEach((item) => {
          if (promotionProduct[item]) {
            promotionProduct[item] =
              (String(promotionProduct[item]).match(/¥|￥/g) || "") +
              Number(String(promotionProduct[item]).replace(/¥|￥|%/g, "")) +
              (String(promotionProduct[item]).match(/%/g) || "");
          }
        });

        good.startTimeCountDown = promotionProduct.startTimeCountDown * 1000;
        good.endTimeCountDown = promotionProduct.endTimeCountDown * 1000;
        good.highCommission = promotionProduct.highCommission;
        good.wechatSaleCommission = promotionProduct.wechatSaleCommission;
        good.appSaleCommission = promotionProduct.appSaleCommission;

        this.floatCommList.push(good);
      }
    },

    // 处理海报是否显示
    handlePosterVisible: function (good) {
      // 是否需要展示海报
      if (good.valueableCateId) {
        //  不在Ios审核期间 && 有奖励
        if (
          !this.isIOSReviewing &&
          (good.sellComm ||
            good.agencyComm ||
            good.appSellComm ||
            good.appAgencyComm)
        ) {
          good.valueablePoster = true;
        } else {
          good.valueablePoster = false;
        }
      } else {
        good.valueablePoster = false;
      }
    },

    //最高奖励
    getComm: function (comm, good) {
      if (!comm) {
        return 0;
      }
      if (comm.indexOf("%") > -1) {
        var price = good.maxPrice || good.activityPrice;
        comm = (
          (parseFloat(comm.substring(0, comm.length - 1)) * parseFloat(price)) /
          100
        ).toFixed(2);
        comm = parseFloat(comm);
      } else {
        comm = parseFloat(comm.substring(1));
      }
      if (this.isInApp) {
        this.appSellComm = this.appSellComm > comm ? this.appSellComm : comm;
      } else {
        this.sellComm = this.sellComm > comm ? this.sellComm : comm;
      }
      return comm;
    },

    //获取商品绑定的下单任务
    getBindOrderTask: function () {
      var that = this,
        selectCity = "", //用户首页所选择的城市名称
        goodsId = that.getGoodId();

      if (goodsId.length < 1) return false;
      goodsId = goodsId.join(",");

      if (localStorage.getItem("shopping_mall_city")) {
        selectCity = JSON.parse(
          localStorage.getItem("shopping_mall_city")
        ).cityName;
      }

      if (that.storgeTask) {
        sucCb(that.storgeTask);
      }

      Databus({
        url: "/api/ordertask/getBindOrderTask",
        type: "get",
        origin: Origins.API_ACT,
        data: {
          goodsId: goodsId,
          selectCity: selectCity || "",
        },
        success: function (res) {
          if (res.code == 1000 && res.bcode == 100) {
            res.content = res.content || {};
            sucCb(res.content.list || []);
          }
        },
      });

      function sucCb(taskList) {
        var goodsListArr = ["activityGoodsList", "commonGoodsList"];

        for (var j = 0, jLength = goodsListArr.length; j < jLength; j++) {
          for (
            var i = 0, length = that[goodsListArr[j]].length;
            i < length;
            i++
          ) {
            var list = that[goodsListArr[j]][i]["list"];
            for (var k = 0, len = list.length; k < len; k++) {
              var tempGoods = list[k];
              if (taskList[tempGoods.goodId]) {
                for (var l = 0; l < taskList[tempGoods.goodId].length; l++) {
                  if (taskList[tempGoods.goodId][l].type == 2) {
                    tempGoods.taskId = taskList[tempGoods.goodId][l].taskId;
                    break;
                  }
                }
              }
            }
          }
        }

        if (!that.storgeTask) {
          that.storgeTask = taskList;
        }
      }
    },
    // .............................................. 接口相关 end ..............................................

    // .............................................. 海报相关 ..............................................
    // 获取海报接口
    handleGetAjaxPoster() {
      return new Promise((resolve, reject) => {
        if (this.posterImg) {
          resolve();
        }

        this.getPoster({
          url: this.shareObjLink,
          scenicID: this.scenicId,
          type: 2,
        })
          .then((url) => {
            this.posterImg = url;
            resolve();
          })
          .catch((err) => {
            console.log("获取酒景海报失败", err);
            reject();
          });
      });
    },
    // 生成酒景页海报
    createGoodsPoster: function () {
      const that = this;
      //获取酒景海报图
      this.handleGetAjaxPoster().then(
        () => {
          // 大数据锚点 -- 生成海报
          if (!this.isInApp) {
            this.logHelpers({
              event_id: "500081",
            });
          }

          if (this.isInApp) {
            this.callApp("showProductPoster", {
              params: {
                anchorData: {
                  item_id: that.scenicId || "",
                  type: "scenic",
                  activity_id: that.activityId || "",
                  source: "scenic",
                },
                posterUrl: that.getAppPosters(
                  that.posterImg,
                  "",
                  that.goodsDetails.album
                ),
                posterImgCount: that.posterImg.length,
                copyText:
                  that.goodsDetails.hotelScenicName +
                  (that.goodsDetails.description
                    ? "-" + that.goodsDetails.description
                    : ""),
                miniShareTitle: this.shareObj.miniShareTitle,
                miniShareImgUrl: this.shareObj.miniShareImgUrl,
                linkChannel: "wechat#wechattimeline#qq#sweibo",
              },
            });
          } else {
            window.componentCenter.multiplePosters.showBox(that.posterImg);
          }
        },
        () => {
          // if (!this.posterImgForPromotion) {
          toast("海报图生成失败，请刷新页面重试");
          //     return;
          // }
        }
      );
    },
    // .............................................. 海报相关 end..............................................

    // .............................................. 跳转相关 ..............................................

    //跳转到首页
    goHomePage: function (opt) {
      var that = this;
      if (opt && opt.logAnchors) {
        this.logHelpers({
          event_id: "500139",
          cb: function () {
            goHomePageHelper();
          },
        });
      } else {
        goHomePageHelper();
      }

      function goHomePageHelper() {
        if (that.isShop) {
          location.href =
            "/front/promoter/myShop?" +
            toQueryString({
              weChatId: 1,
              promotion: sessionStorage.getItem("isShop_promotion") || "",
            });
          return;
        }

        if (that.isInApp) {
          that.callApp("toAppIndex");
          return true;
        }

        if (isYkzMiniprogram()) {
          const url = encodeURIComponent(
            window.location.origin + "/front/promoter/shoppingMallv2?weChatId=1"
          );
          wx.miniProgram.reLaunch({
            url: `/pages/index/index?url=` + url,
          });
          return;
        } else {
          that.goHelper(
            "/front/promoter/shoppingMallv2?weChatId=1" + toQueryString()
          );
        }
      }
    },
    //跳转到产品详情页
    goProductDetails: function (good) {

      // 大数据锚点
      var that = this;

      // 点击产品项跳转
      this.logHelpers({
        event_id: "500078",
        event_content: {
          good_id: good.goodId,
          pos: good.isActivity ? 1 : 2,
          channel_id: window.sessionStorage.getItem("channel_ref") || "",
        },
        cb: function () {
          goProductDetailsHelper();
        },
      });

      function goProductDetailsHelper() {
        var url = that.getProductDetailsUrl(good, "mini");
        if (url) {
          url = that.addAnchorDatas(url, "scenicDetail");
          // 兼容rn
          if (that.weChatId == 1) {
            url = updateUrlParam(url, "showAllWechat", 1);
          }
          // 兼容奖励上浮
          that.storgeDate();
          that.goHelper(url, "mini");
        }
      }
    },
    // 获取产品详情的链接
    getProductDetailsUrl: function (good, platForm = "h5") {
      var url = "";
      good.goodsId = good.goodId;
      good.weChatId = good.weChatId || this.weChatId;
      url = getProductLink(good, platForm);

      return url;
    },

    // 仅保留对象中值为真的属性
    getTrueObj: function (obj) {
      var res = {};
      for (let key in obj) {
        if (obj[key]) {
          res[key] = obj[key];
        }
      }
      return res;
    },

    goBookDirectly: function (good, type) {
      if (good.cateId == 8 && !good.isMultiPrice) {
        if (this.isTourist && this.isInApp) {
          this.goAppLogin();
          return false;
        }
        const time = +new Date();
        let goodStatus = false;

        if (type === 1) {
          const { startTime } = good;
          if (time >= startTime * 1000) {
            goodStatus = true;
          }
        } else {
          const { validityStartTime } = good;
          if (time >= validityStartTime * 1000) {
            goodStatus = true;
          }
        }

        if (goodStatus) {
          this.goBook(good, type);
        } else {
          type === 1 ? this.goProductDetails(good) : this.goRoomDetail(good, 0);
        }
      } else {
        type === 1 ? this.goProductDetails(good) : this.goRoomDetail(good, 0);
      }
    },

    // 跳转到预定页
    goBook: function (good, type) {
      var that = this;
      // 点击预定
      YCF_Plugin.reportUserAnchors(
        {
          event_id: "500078",
          event_content: {
            item_id: this.scenicId,
            pos: type,
            good_id: good.goodId,
            scenicFrom: getUrlParams("scenicFrom") || "",
            channel_id: window.sessionStorage.getItem("channel_ref") || "",
          },
          page_name: "酒景详情页",
        },
        {
          logChannel: true,
        }
      ).always(function () {
        that.getBookUrl(good);
      });
    },

    getBookUrl: function (good) {
      this.storgeDate();
      // 门票
      let url =
        "/front/index/entranceTicketReserve?weChatId=" +
        good.weChatId +
        "&goodId=" +
        good.goodId;
      if (good.isActivity) {
        url += "&activityId=" + good.activityId;
      }

      this.goHelper(url);
      return;
    },

    //跳转到图文详情页
    goPraphic: function () {
      var that = this;
      YCF_Plugin.anchorPoint(
        "酒景页游玩攻略",
        "productdetail_method",
        `scenicId:${this.scenicId}`
      );

      this.logHelpers({
        event_id: "520003",
        element_content: "clickPlayStrategy",
        cb: function () {
          let url =
            "/front/platform/platformFeature?scenicId=" +
            that.scenicId +
            "&weChatId=" +
            that.weChatId +
            "&fromWeChatId=" +
            that.fromWeChatId;

          that.goHelper(url);
        },
      });
    },

    //跳转到相册页
    goAlbum: function () {
      var that = this;
      this.logHelpers({
        event_id: "520003",
        element_content: "clickPhoto",
        cb: function () {
          if (that.goodsDetails.isHasAlbum) {
            let url =
              "/front/platform/platformAlbum?scenicId=" +
              that.scenicId +
              "&weChatId=" +
              that.weChatId +
              "&fromWeChatId=" +
              that.fromWeChatId;

            that.goHelper(url);
          }
        },
      });
    },

    //跳转到评论页
    goEvaluation: function (element_content) {
      var that = this;
      this.logHelpers({
        event_id: "520003",
        element_content: element_content || "",
        cb: function () {
          if (!that.commentInfos || !that.commentInfos.commentCount) {
            return false;
          }
          let url =
            "/front/index/userEvaluation?scenicId=" +
            that.scenicId +
            "&weChatId=" +
            that.weChatId +
            "&fromWeChatId=" +
            that.fromWeChatId;

          that.goHelper(url);
        },
      });
    },

    //跳转到咨询页
    goAdvisory: function () {
      var that = this;
      this.logHelpers({
        event_id: "520003",
        element_content: "clickMoreConsultation",
        cb: function () {
          let url =
            "/front/index/userAdvisory?scenicId=" +
            that.scenicId +
            "&weChatId=" +
            that.weChatId +
            "&fromWeChatId=" +
            that.fromWeChatId;

          that.goHelper(url);
        },
      });
    },

    //跳转到app登录界面
    goAppLogin: function () {
      this.callApp("goLogin");
    },

    // 跳转到素材页
    goMaterial: function () {
      var that = this;

      this.logHelpers({
        event_id: "500203",
        cb: function () {
          if (that.isInApp) {
            that.callApp("showMaterialPage", {
              params: {
                scenicId: that.scenicId,
                fail_cb: goH5Material,
                productName: that.goodsDetails.hotelScenicName,
                attachUrl:
                  that.goodsDetails.coverImg ||
                  "/srcv2/images/loading_img_750_400.png",
                city: that.goodsDetails.cityName,
                minPrice: that.getMinPrice(),
                sellComm: "¥" + that.appSellComm,
                isMultiSpec:
                  that.activityGoodsList.length > 0 ||
                  that.commonGoodsList.length > 0,
              },
              fail_cb: function () {
                that.showDownloadTips = true;
              },
            });
          } else {
            goH5Material();
          }
        },
      });

      function goH5Material() {
        that.goHelper(
          "/front/promoter/material?" +
          toQueryString({
            weChatId: that.weChatId,
            fromWeChatId: that.fromWeChatId,
            scenicId: that.scenicId,
          })
        );
      }
    },

    // 跳转助手
    goHelper: function (url, platform) {
      if (this.isOtherBrowsers) {
        url = updateUrlParam(url, "promotion", this.promotion || "");
        if (url.indexOf("Reserve") > -1) {
          url = updateUrlParam(url, "bookFrom", "scenicDetail");
        }
      }
      if (this.isShop) {
        url = updateUrlParam(url, "isShop", this.isShop || "");
        url = updateUrlParam(
          url,
          "promotion",
          sessionStorage.getItem("isShop_promotion") || ""
        );
      }
      if (platform === "mini") {
        goToWxMiniPage(url);
      } else {
        if (this.fromPlatform) {
          url = updateUrlParam(url, "fromPlatform", this.fromPlatform);
        }
        location.href = YCF_Plugin.getNavigateUrl(url, {});
      }
    },

    // 跳转到任务页
    goTask: function (good) {
      location.href =
        "/front/promoter/taskDetails?" +
        toQueryString({
          taskId: good.taskId,
          weChatId: 1,
          fromPlatform: this.fromPlatform,
        });
    },

    expandGroup: function (index, type) {
      if (type === 1) {
        var status1 = this.activityGoodsList[index].isExpand;
        this.$set(this.activityGoodsList[index], "isExpand", !status1);
      } else {
        var status2 = this.commonGoodsList[index].isExpand;
        this.$set(this.commonGoodsList[index], "isExpand", !status2);
      }
    },

    handleShowAppExclusive: function (good) {
      this.showAppExclusive = true;
      this.showAppExclusiveGood = good;
    },
  },
};

export default page;
